import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Policy } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/Policy';

export const ResetPasswordTerms = observer('ResetPasswordTerms', () => {
    return <Policy id='terms-and-conditions' />;
});
